{
  "PoundUkStd": "£ - Sterlina britannica",
  "PoundUkIso": "GBP - Sterlina britannica",
  "DollarUsaStd": "$ - Dollaro statunitense",
  "DollarUsaOther": "US$ - Dollaro statunitense",
  "DollarUsaIso": "USD - Dollaro statunitense",
  "DollarCanadaEnglishStd": "$ - Dollaro canadese (inglese)",
  "DollarCanadaEnglishOther": "C$ - Dollaro canadese (inglese)",
  "DollarCanadaFrenchStd": "$ - Dollaro canadese (francese)",
  "DollarCanadaFrenchOther": "C$ - Dollaro canadese (francese)",
  "DollarCanadaIso": "CAD - Dollaro canadese",
  "DollarAustraliaStd": "$ - Dollaro australiano",
  "DollarAustraliaOther": "A$ - Dollaro australiano",
  "DollarAustraliaIso": "AUD - Dollaro australiano",
  "DollarNewzealandStd": "$ - Dollaro neozelandese",
  "DollarNewzealandOther": "NZ$ - Dollaro neozelandese",
  "DollarNewzealandIso": "NZD - Dollaro neozelandese",
  "DollarSingaporeStd": "$ - Dollaro di Singapore",
  "DollarSingaporeOther": "S$ - Dollaro di Singapore",
  "DollarSingaporeIso": "SGD - Dollaro di Singapore",
  "DollarHongkongStd": "$ - Dollaro di Hong Kong",
  "DollarHongkongOther": "HK$ - Dollaro di Hong Kong",
  "DollarHongkongIso": "HKD - Dollaro di Hong Kong",
  "EuroGeneralStd": "€ - Euro (Generale)",
  "EuroFrenchStd": "€ - Euro (francese)",
  "EuroGermanStd": "€ - Euro (tedesco)",
  "EuroItalianStd": "€ - Euro (italiano)",
  "EuroIso": "EUR - Euro",
  "YenJapanStd": "¥ - Yen giapponese",
  "YenJapanIso": "JPY - Yen giapponese",
  "FrancSchwitzerlandFrenchStd": "fr. - Franco svizzero (francese)",
  "FrancSchwitzerlandGermanStd": "Fr. - Franco svizzero (tedesco)",
  "FrancSchwitzerlandItalianStd": "fr. - Franco svizzero (italiano)",
  "FrancSchwitzerlandIso": "CHF - Franco svizzero",
  "YuanChinaStd": "¥ - Yuan cinese Renminbi",
  "YuanChinaIso": "CNY - Yuan Renminbi cinese",
  "PesoMexicoStd": "$ - Peso messicano",
  "PesoMexicoIso": "MXN - Peso messicano",
  "KronaSwedenStd": "kr - Corona svedese",
  "KronaSwedenIso": "SEK - Corona svedese",
  "KroneNorwayStd": "kr - Corona norvegese",
  "KroneNorwayIso": "NOK - Corona norvegese",
  "WonSouthkoreaStd": "₩ - Won sudcoreano",
  "WonSouthkoreaIso": "KRW - Won sudcoreano",
  "LiraTurkeyStd": "₺ - Lira turca",
  "LiraTurkeyIso": "TRY - Lira turca",
  "RupeeIndiaStd": "₹ - Rupia indiana",
  "RupeeIndiaIso": "INR - Rupia indiana",
  "RupleRussiaStd": "₽ - Rublo russo",
  "RupleRussiaIso": "RUB - Rublo russo",
  "RealBrazilStd": "R$ - Real brasiliano",
  "RealBrazilIso": "BRL - Real brasiliano",
  "RandSouthafricaStd": "R - Rand sudafricano",
  "RandSouthafricaIso": "ZAR - Rand sudafricano",
  "NAME": "Currency"
}